import { alpha } from "@mui/material/styles";
import { toMuiVariants } from "../../design/toMuiVariants";
import { typographyRecipe } from "../../design/recipes/typographyRecipes";
import { TYPOGRAPHY_VARIANTS } from "../../design/typographyVocabulary";
export const getDatadisplayOverrides = (theme) => ({
    MuiTypography: {
        defaultProps: {
          variantMapping: {
            h0: "h1",
            h1: "h2",
            h2: "h2",
            h3: "h3",
            h4: "h4",
            h5: "h5",
            h6: "h6",
            h7: "span",
            subtitle1: "p",
            subtitle2: "p",
            body1: "p",
            body2: "p",
            sectionEyebrow: "span",
            sectionTitle: "h2",
            pageTitle: "h1",
            pageHeader: "h2",
            sectionHeader: "h2",
            sectionHeaderLarge: "h2",
            languageGlyph: "span",
            drawerUserName: "p",
            subsectionTitle: "h2",
            readingBody: "p",
            analyticsValue: "span",
            cardTitle: "h3",
            fieldLabel: "span",
            fieldLabelSmall: "span",
            filterLabel: "label",
            dialogTitle: "h2",
            dialogBody: "p",
            ...Object.fromEntries(TYPOGRAPHY_VARIANTS.map((name) => [name, "span"])),
            
          },
        },
        variants: [
          ...toMuiVariants(typographyRecipe),
          {
            props: { variant: "sectionEyebrow" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "sectionTitle" },
            style: () => ({}),
          },
          {
            props: { variant: "cardTitle" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "dialogTitle" },
            style: () => ({}),
          },
          {
            props: { variant: "dialogBody" },
            style: () => ({}),
          },
          {
            props: { variant: "filterLabel" },
            style: () => ({}),
          },
          {
            props: { variant: "pageTitle" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "pageHeader" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "sectionHeader" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "sectionHeaderLarge" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "languageGlyph" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "drawerUserName" },
            style: () => ({}),
          },
          {
            props: { variant: "subsectionTitle" },
            style: () => ({}),
          },
          {
            props: { variant: "readingBody" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "fieldLabel" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "fieldLabelSmall" },
            style: () => ({}), // styles live in typography block above; slot needed for variant recognition
          },
          {
            props: { variant: "primary" },
            style: ({ theme }) => ({
              color: theme.palette.text.primary,
            }),
          },
          {
            props: { variant: "error" },
            style: ({ theme }) => ({
              color: theme.palette.text.error,
            }),
          },
          {
            props: { variant: "primary-green" },
            style: ({ theme }) => ({
              color: theme.palette.text.textGreen,
            }),
          },
        ],
      },
    MuiTableRow: {
        styleOverrides: {
          // background.tertiaryGreen stays light in dark mode, so dark needs its own hover surface.
          root: ({ theme }) => ({
            "&.MuiTableRow-hover:hover": {
              backgroundColor:
                theme.palette.mode === "dark"
                  ? theme.palette.action.hover
                  : alpha(theme.palette.background.tertiaryGreen, 0.5),
            },
          }),
        },
      },
    MuiSkeleton: {
        styleOverrides: {
          root: {
            backgroundColor: alpha(theme.palette.common?.black , 0.08),
          },
          rounded: {
            borderRadius: "8px",
          },
        },
      },
});
